import React from 'react';
import { Box, Divider, Grid, Link, List, ListItem, Typography } from '@mui/material';
import SearchBar from '../modules/Header/Search';
import Image10 from '../assets/images/search-banner.jpg';

const Search = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box>
        <img src={Image10} alt="" width="100%" />
      </Box>
      <Box
        sx={{
          width: '100%',
          maxWidth: '900px',
          margin: '-140px auto 0',
        }}
      >
        <Box
          sx={{
            background: '#fff',
            borderRadius: '10px',
            boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.15)',
            padding: '35px 40px 40px',
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: 35, fontWeight: 500, color: '#1F1F1F', textAlign: 'center' }}>
                Vehicle 360
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <SearchBar
                searchStyle={{
                  background: '#fff',
                  padding: '5px 20px 5px 10px',
                  margin: '20px 0 0',
                  borderRadius: '38px',
                  border: '1px solid #e3e3e3',
                }}
                searchInputStyle={{
                  fontSize: '18px',
                  color: '#A2A2A2',
                  width: '100%',
                  padding: '9px 12px',
                }}
                searchListBox={{
                  width: '100%',
                  maxWidth: '740px',
                  borderRadius: '8px',
                  maxHeight: '400px',
                  height: 'auto',
                }}
                searchIconStyle={{
                  fontSize: 26,
                }}
              />
            </Grid>
            {/* <Grid item xs={12}>
            <List sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
              <ListItem sx={{ width: 'auto', padding: '0 6px' }}>
                <Typography fontSize={14} fontWeight={500} color="#1F1F1F">
                  Recent Search:
                </Typography>
              </ListItem>
              <ListItem sx={{ width: 'auto', padding: '0 6px' }}>
                <Typography>
                  <Link href="/" sx={{ fontSize: 14, fontWeight: 500, color: '#456BD9', textDecoration: 'none' }}>
                    Upcoming Deliveries
                  </Link>
                </Typography>
              </ListItem>
              <ListItem sx={{ width: 'auto', padding: '0 6px' }}>
                <Divider orientation="vertical" sx={{ borderBottom: '1px solid #E1E0DC', height: '16px' }} />
              </ListItem>
              <ListItem sx={{ width: 'auto', padding: '0 6px' }}>
                <Typography>
                  <Link href="/" sx={{ fontSize: 14, fontWeight: 500, color: '#456BD9', textDecoration: 'none' }}>
                    PDI–Costa Mesa
                  </Link>
                </Typography>
              </ListItem>
            </List>
          </Grid> */}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Search;
